import angular from 'angular';
import {MdDataTableRenderer} from './md-data-table-renderer.directive';
import {MdBadge} from './md-badge.directive';
/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.directives', [])
  .directive('mdDataTableRenderer', () => new MdDataTableRenderer())
  .directive('mdBadge', () => new MdBadge())
  .name;
